<template>
  <div class="container">
    <div class="step-box" v-if="from && from === 'quick'">
      <div class="step-title">
        <div class="step-num">4</div>
        <div class="step-name">提交成功,确认并支付</div>
      </div>
      <div class="step-desc">
        系统自动计算报价,确认无误后选择支付方式并支付,我们将安排专业制作,严格质检,尽快送达你的手中
      </div>
    </div>
    <div class="page">
      <div class="header">
        <div class="left">
          订单提交成功，请尽快付款！订单号：{{ detail.order_no }}
        </div>
        <div class="right">
          <div class="money-box">
            预付款 <span class="money">￥{{ total_price | price_format }}</span>
          </div>
          <div class="pay-tips">
            说明:该费用只包含款式基础制作费用,如涉及印绣花,特殊工艺等,待客服确认后另行支付,敬请知悉!
          </div>
        </div>
      </div>
      <div class="virtual-box" v-if="from && from === 'quick'">
        <div
          class="virtual-item"
          v-if="
            setting.c_coupon_deduct_coupon > 0 &&
            setting.max_c_coupon_deduct_ratio
          "
        >
          <div class="item-name">
            <input
              type="checkbox"
              :checked="useCCouponDeduct"
              @change="switchCCouponChange"
            />消费券抵扣<span
              >(当前账号消费券{{ userInfo.c_coupon || 0 }})</span
            >
          </div>
          <div class="item-price">-¥{{ c_coupon_pay_money }}</div>
        </div>
        <div
          class="virtual-item"
          v-if="
            pointSetting.shoppingDeductPoint > 0 &&
            pointSetting.maxDeductRatio > 0
          "
        >
          <div class="item-name">
            <input
              type="checkbox"
              :checked="usePointDeduct"
              @change="switchPointChange"
            />积分抵扣<span>(当前账号积分{{ userInfo.point || 0 }})</span>
          </div>
          <div class="item-price">-¥{{ point_pay_money }}</div>
        </div>
      </div>
      <div class="pay-methods" v-if="from && from === 'quick'">
        <div class="pay-title">支付方式:</div>
        <div class="methods-box">
          <!-- <div class="method-items">支付宝支付</div> -->
          <div
            :class="['method-items', { active: pay_type === 'wechat' }]"
            @click="onPayMethodChange('wechat')"
          >
            微信支付
            <img
              v-if="pay_type === 'wechat'"
              src="../../assets/images/icon-selected-paymethods.png"
              alt=""
              class="selected-icon"
            />
          </div>
          <div
            :class="['method-items', { active: pay_type === 'alipay' }]"
            @click="onPayMethodChange('alipay')"
          >
            支付宝支付
            <img
              v-if="pay_type === 'alipay'"
              src="../../assets/images/icon-selected-paymethods.png"
              alt=""
              class="selected-icon"
            />
          </div>
          <div
            :class="['method-items', { active: pay_type === 'offline' }]"
            @click="onPayMethodChange('offline')"
          >
            线下支付
            <img
              v-if="pay_type === 'offline'"
              src="../../assets/images/icon-selected-paymethods.png"
              alt=""
              class="selected-icon"
            />
          </div>
          <div
            :class="['method-items', { active: pay_type === 'balance' }]"
            @click="onPayMethodChange('balance')"
          >
            余额支付(余额:¥:{{ userInfo.available_balance | price_format }})
            <img
              v-if="pay_type === 'balance'"
              src="../../assets/images/icon-selected-paymethods.png"
              alt=""
              class="selected-icon"
            />
          </div>
        </div>
      </div>
      <div class="content">
        <template v-if="pay_type != 'balance'">
          <div class="img-wrap">
            <img :src="pay_type | pay_methods_icon" alt="" class="icon" />
            <span>{{ pay_type | pay_methods_name }}支付</span>
          </div>
          <div v-if="pay_type == 'offline'" class="tip">
            选择线下支付方式，请在
            <span class="second">完成线下支付成功</span>
            后，在下方上传支付凭证图片，才可完成订单下单流程
          </div>
          <div v-else-if="['wechat', 'alipay'].includes(pay_type)" class="tip">
            距离二维码过期还剩
            <span class="second">{{ second }}</span>
            秒，过期后请刷新页面重新获取二维码
          </div>

          <div v-if="pay_type == 'offline'" class="upload-result">
            <Upload
              type="drag"
              :action="upload_url"
              :data="{ dir: 'template' }"
              :multiple="false"
              :on-success="
                (response, file, fileList) =>
                  handleSuccess(response, file, fileList, 'img_list')
              "
              :before-upload="onBeforeUpload"
              :show-upload-list="false"
              :format="format_img"
              :accept="accept_img"
              :disabled="!!pay_result"
            >
              <template>
                <div class="upload-btn" v-if="!pay_result">
                  <img
                    class="btn-icon"
                    src="../../assets/images/icon-upload-cash-result.png"
                  />
                  <div class="btn-text">上传支付凭证图片</div>
                  <div class="btn-desc">支持JPG/PNG/JPEG格式</div>
                  <div class="btn-desc">图片大小≤5M</div>
                </div>
                <div class="upload-res" v-else>
                  <img :src="pay_result" alt="" class="res-img" />
                  <img
                    @click.prevent.stop="pay_result = ''"
                    src="../../assets/images/icon-result-remove.png"
                    alt=""
                    class="remove-btn"
                  />
                </div>
              </template>
            </Upload>
            <div class="upload-tips">
              <div class="tips-title">上传支付凭证图片需求:</div>
              <div class="tips-content">
                <p>1.须包含第三方交易订单号/转账单号/流水号;</p>
                <p>
                  2.可在支付宝、微信、手机银行等平台的支付详情中查找并截图，或拍照银行线下打款凭证;
                </p>
                <p>3.如有疑问，请咨询平台在线客服;</p>
                <p>4.支付凭证包含但不限于以上形式。</p>
                <template
                  v-if="
                    setting.offlinePayName &&
                    setting.offlinePayAccount &&
                    setting.offlinePayBank
                  "
                >
                  <p class="line"></p>
                  <p class="pay-title">收款账户信息:</p>
                  <div class="pay-item">
                    <div class="label">开户名:</div>
                    <div class="value">{{ setting.offlinePayName || "" }}</div>
                  </div>
                  <div class="pay-item">
                    <div class="label">收款账户:</div>
                    <div class="value">
                      {{ setting.offlinePayAccount || "" }}
                      <span
                        v-if="setting.offlinePayAccount"
                        @click="onCopy(setting.offlinePayAccount)"
                        >复制</span
                      >
                    </div>
                  </div>
                  <div class="pay-item">
                    <div class="label">收款银行:</div>
                    <div class="value">{{ setting.offlinePayBank || "" }}</div>
                  </div>
                </template>
              </div>
            </div>
            <div class="btn-box">
              <div class="btn" @click="onOrderPay">确认提交</div>
            </div>
            <div v-if="!from" class="back-btn" @click="onBack">
              < 选择其他支付方式
            </div>
          </div>

          <div
            v-else-if="['wechat', 'alipay'].includes(pay_type)"
            class="code-wrap"
          >
            <div class="left">
              <div class="qrcode">
                <canvas
                  v-if="pay_type === 'wechat'"
                  width="270"
                  height="270"
                  ref="c"
                  id="qrccode-canvas"
                  style="width: 100%; height: 100%"
                ></canvas>
                <template v-else-if="pay_type === 'alipay'">
                  <iframe
                    v-if="alipayFormContent"
                    ref="alipayIframe"
                    width="270"
                    height="270"
                    frameborder="0"
                    style="width: 100%; height: 100%"
                    :srcdoc="alipayFormContent"
                  ></iframe>
                </template>
                <p class="hint">
                  请使用{{ pay_type | pay_methods_name }}扫一扫<br />
                  扫描二维码支付
                </p>
              </div>
            </div>
            <div class="right">
              <img :src="pay_type | pay_methods_help" alt="" class="help" />
            </div>
          </div>
        </template>
        <template v-else>
          <div class="balance-pay">
            <div class="balance-pay-btn" @click="onOrderPay">确认支付</div>
          </div>
        </template>
      </div>
    </div>
    <quick-pay-result
      v-if="show_result"
      :info="{
        order_uuid: uuid,
        amount: payable_amount,
        address: `${detail.province}${detail.city}${detail.zone}${detail.address} ${detail.contact_person} ${detail.contact_mobile}`,
      }"
    ></quick-pay-result>
  </div>
</template>

<script>
let QRCode = require("qrcode");
import {
  CheckPayStatus,
  CheckoutOrder,
  OrderDetail,
  PayOrder,
  Profile,
  getSetting,
} from "@/api/index.js";
import axios from "axios";
import { mapState } from "vuex";
import QuickPayResult from "./Component/QuickPayResult";
export default {
  name: "CashDesk",
  components: {
    QuickPayResult,
  },
  data() {
    return {
      uuid: "",
      pay_type: "",
      detail: {},
      second: 300,
      interval_id1: null,
      interval_id2: null,
      log_id: 0,
      upload_url: process.uniEnv.BASE_API + "/util/upload-image",
      format_img: ["jpg", "jpeg", "png", "gif"],
      accept_img: ".jpg,.jpeg,.png,.gif",
      pay_result: "",
      from: "",
      show_result: false,
      useCCouponDeduct: false,
      usePointDeduct: false,
      pointSetting: {
        shoppingDeductPoint: 0,
        maxDeductPoint: 0,
      },
      alipayFormContent: "",
    };
  },
  computed: {
    ...mapState(["setting", "userInfo"]),
    payable_amount() {
      if (this.detail.is_deposit == 1 && Number(this.detail.deposit_price) > 0) {
        return Number(this.detail.deposit_price);
      }
      return Number(this.detail.total_price || 0);
    },
    c_coupon_pay_money() {
      let c_coupon_pay_money = 0;
      if (this.useCCouponDeduct) {
        let maxDeductPrice =
          (this.setting.max_c_coupon_deduct_ratio / 100) *
          this.payable_amount;
        if (
          this.userInfo.c_coupon * this.setting.c_coupon_deduct_coupon >=
          maxDeductPrice
        ) {
          c_coupon_pay_money = maxDeductPrice;
        } else {
          c_coupon_pay_money = Number(
            this.userInfo.c_coupon * this.setting.c_coupon_deduct_coupon,
          );
        }
        return c_coupon_pay_money.toFixed(2);
      }
      return c_coupon_pay_money;
    },
    point_pay_money() {
      if (this.usePointDeduct) {
        var maxDeductPrice =
          (this.pointSetting.maxDeductRatio / 100) *
          (this.payable_amount - this.c_coupon_pay_money);
        let point_pay_money;
        if (
          this.userInfo.point * this.pointSetting.shoppingDeductPoint >
          maxDeductPrice
        ) {
          point_pay_money = maxDeductPrice;
        } else {
          point_pay_money =
            this.userInfo.point * this.pointSetting.shoppingDeductPoint;
        }
        return point_pay_money.toFixed(2);
      }
      return 0;
    },
    virtual_pay_money() {
      return Number(this.point_pay_money) + Number(this.c_coupon_pay_money);
    },
    total_price() {
      return Number(
        this.payable_amount -
          this.c_coupon_pay_money -
          this.point_pay_money,
      ).toFixed(2);
    },
  },
  beforeRouteLeave(to, from, next) {
    this.stopPayPolling();
    next();
  },
  beforeDestroy() {
    this.stopPayPolling();
  },
  methods: {
    stopPayPolling() {
      if (this.interval_id1) {
        clearInterval(this.interval_id1);
        this.interval_id1 = null;
      }
      if (this.interval_id2) {
        clearInterval(this.interval_id2);
        this.interval_id2 = null;
      }
    },
    switchPointChange(e) {
      this.usePointDeduct = !this.usePointDeduct;
      this.onPayMethodChange(this.pay_type);
    },
    switchCCouponChange(e) {
      this.useCCouponDeduct = !this.useCCouponDeduct;
      this.onPayMethodChange(this.pay_type);
    },
    async getPointSetting() {
      let { data } = await getSetting({ code: "user", key: "pointSetting" });
      if (data) {
        this.pointSetting = data;
      }
    },
    onPayMethodChange(type) {
      this.stopPayPolling();
      ['wechat', 'alipay'].includes(type) ? this.onCheckout(type) : (this.pay_type = type);
    },
    async onCopy(account) {
      if (!account) return;
      await navigator.clipboard.writeText(account);
      this.$layer.msg("复制成功");
    },
    onBack() {
      this.$router.replace({
        name: "WorkBenchCheckout",
        query: { uuid: this.uuid },
      });
    },
    onBeforeUpload() {
      if (this.pay_result) {
        return false;
      }
    },
    handleSuccess(response, file, fileList, field) {
      if (field === "img_list") {
        this.pay_result = response.data.url;
      }
    },
    generate(url) {
      QRCode.toCanvas(this.$refs.c, url, { width: 270 }, (error) => {
        if (error) {
          console.log(error);
        }
      });
    },
    async getProfile() {
      return Profile().then((response) => {
        return response;
      });
    },
    onCheckout(type) {
      const pay_param = {
        use_balance: false,
        use_wechat: false,
        use_offline: false,
        usePointDeduct: this.usePointDeduct,
        useCCouponDeduct: this.useCCouponDeduct,
      };
      let is_virtual_pay = this.usePointDeduct || this.useCCouponDeduct;
      let is_online_pay = pay_param.use_wechat;
      CheckoutOrder({ uuid: this.uuid, pay_param }).then(({ data }) => {
        // 虚拟财产支付足够订单金额
        if (this.virtual_pay_money >= this.payable_amount) {
          this.payBalance();
          return;
        }
        //使用余额且余额足够支付订单剩余金额
        if (
          pay_param.use_balance &&
          Number(this.userInfo.available_balance) >=
            Number(this.payable_amount - this.virtual_pay_money)
        ) {
          this.payBalance();
          return;
        }
        //>只有余额支付操作
        if (pay_param.use_balance && !is_online_pay) {
          this.payBalance();
          return;
        }
        this.pay_type = type;
        if (["wechat", "alipay"].includes(this.pay_type)) {
          this.onOrderPay();
        }
      });
    },
    payBalance() {
      const param = {};
      param.uuid = this.form_data.uuid;
      param.pay_type = "balance";
      param.usePointDeduct = this.usePointDeduct;
      param.useCCouponDeduct = this.useCCouponDeduct;
      this.$Spin.show();
      PayOrder(param)
        .then((res) => {
          console.log("res-pay", res);
          this.$layer.msg("支付成功");
          this.show_result = true;
        })
        .catch((e) => {
          console.log("err-pay", e);
          this.$layer.msg(e.msg);
        })
        .finally(() => {
          this.$Spin.hide();
        });
    },
    onOrderPay() {
      const { uuid, pay_type, pay_result } = this;
      const param = {};
      param.uuid = uuid;
      param.pay_type = pay_type;
      pay_type === "offline" ? (param.pay_result = pay_result) : null;
      PayOrder(param)
        .then((response) => {
          console.log("response", response);
          if (pay_type === "wechat") {
            this.generate(response.data.url);
            this.stopPayPolling();
            this.interval_id1 = setInterval(() => {
              this.second--;
              if (this.second === 0) {
                this.stopPayPolling();
                this.second = 300;
                location.reload();
              }
            }, 1000);
            this.interval_id2 = setInterval(() => {
              CheckPayStatus({ pay_id: response.data.pay_id }).then((res) => {
                if (res.data.status === 1) {
                  this.stopPayPolling();
                  if (this.from !== "quick") {
                    this.$router.replace({
                      name: "PayResult",
                      query: { uuid: this.uuid },
                    });
                  } else {
                    this.show_result = true;
                  }
                }
              });
            }, 3000);
          } else if (pay_type === "alipay") {
            if (response.data.type === "form") {
              this.alipayFormContent = response.data.content;
              setTimeout(() => {
                const iframe = this.$refs.alipayIframe;
                if (iframe && iframe.contentDocument) {
                  const form = iframe.contentDocument.querySelector("form");
                  if (form) {
                    form.submit();
                  }
                }
              }, 500);
            } else if (response.data.url) {
              this.generate(response.data.url);
            }
            this.stopPayPolling();
            this.interval_id1 = setInterval(() => {
              this.second--;
              if (this.second === 0) {
                this.stopPayPolling();
                this.second = 300;
                location.reload();
              }
            }, 1000);
            this.interval_id2 = setInterval(() => {
              CheckPayStatus({ pay_id: response.data.pay_id }).then((res) => {
                if (res.data.status === 1) {
                  this.stopPayPolling();
                  if (this.from !== "quick") {
                    this.$router.replace({
                      name: "PayResult",
                      query: { uuid: this.uuid },
                    });
                  } else {
                    this.show_result = true;
                  }
                }
              });
            }, 3000);
          } else {
            if (this.from !== "quick") {
              this.$router.replace({
                name: "PayResult",
                query: { uuid: this.uuid },
              });
            } else {
              this.show_result = true;
            }
          }
        })
        .catch((e) => {
          this.$layer.msg(e.msg);
        });
    },
  },
  async mounted() {
    const { uuid, pay_type, from } = this.$route.query;
    this.uuid = uuid;
    this.pay_type = pay_type;
    this.from = from;
    if (this.$route.query.uuid) {
      let response = await OrderDetail({
        uuid: this.$route.query.uuid,
      });
      this.detail = response.data;
      if (this.detail.status == 1) {
        this.$router.replace({
          name: "PayResult",
          query: { uuid: this.uuid },
        });
        return;
      }
    }
    this.getPointSetting();
    //this.pay_type != "offline"
    if (["wechat", "alipay"].includes(this.pay_type)) {
      this.onOrderPay();
    }
    axios.all([this.getProfile()]).then(axios.spread(() => {}));
  },
};
</script>

<style scoped lang="scss">
.container {
  background: #f6f7fa;
  padding: 30px 200px 100px 200px;

  .step-box {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 22px;
    margin-bottom: 15px;

    .step-title {
      display: flex;
      align-items: center;
      column-gap: 10px;

      .step-num {
        width: 20px;
        height: 20px;
        background: #1a1a1a;
        border-radius: 5px;
        line-height: 20px;
        text-align: center;
        color: #ffffff;
        font-size: 14px;
      }

      .step-name {
        color: #333333;
        font-size: 18px;
        font-weight: 500;
      }
    }

    .step-desc {
      color: #999999;
      font-size: 13px;
    }
  }

  .page {
    width: 1500px;
    margin: 0 auto;
    padding: 0 70px;
    background: white;
    border-radius: 10px 10px 10px 10px;

    .virtual-box {
      display: flex;
      flex-direction: column;
      row-gap: 20px;
      margin-top: 25px;
      .virtual-item {
        display: flex;
        align-items: center;
        column-gap: 23px;
        .item-name {
          display: flex;
          align-items: center;
          color: #333;
          font-size: 14px;
          span {
            color: #666;
            font-size: 12px;
          }
        }
        .item-price {
          color: #fa3d5a;
          font-size: 14px;
          font-weight: bold;
        }
      }
    }

    .pay-methods {
      display: flex;
      align-items: center;
      column-gap: 30px;
      margin-top: 30px;

      .pay-title {
        color: #333333;
        font-size: 16px;
        font-weight: bold;
      }

      .methods-box {
        display: flex;
        align-items: center;
        column-gap: 20px;

        .method-items {
          color: #333333;
          font-size: 16px;
          padding: 17px 35px;
          border: 1px solid #cccccc;
          position: relative;
          cursor: pointer;

          &.active {
            border: 1px solid #3478ff;
          }

          .selected-icon {
            position: absolute;
            top: 0;
            right: 0;
            width: 30px;
            height: 24px;
          }
        }
      }
    }

    .header {
      height: 92px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #dbdbdb;
      color: #333;

      .right {
        display: flex;
        flex-direction: column;
        align-items: end;
        .money-box {
          .money {
            font-size: 24px;
            color: #fa3d5a;
          }
        }
        .pay-tips {
          font-size: 12px;
          margin-top: 10px;
          color: red;
        }
      }
    }

    .content {
      .img-wrap {
        display: flex;
        align-items: center;
        font-size: 26px;
        margin: 25px 0;

        .icon {
          width: 32px;
          height: 32px;
          margin-right: 10px;
        }
      }

      .tip {
        color: #737373;
        font-size: 14px;

        .second {
          color: #fa3d5a;
        }
      }

      .code-wrap {
        padding: 66px 0 200px 0;
        display: flex;
        justify-content: center;
        align-items: center;

        .left {
          .qrcode {
            width: 270px;
            height: 270px;
          }

          .hint {
            background: #fa3d5a;
            padding: 5px 10px;
            color: white;
            text-align: center;
          }
        }

        .right {
          .help {
            margin-left: 100px;
            width: 250px;
            height: 320px;
          }
        }
      }

      .upload-result {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        column-gap: 75px;
        margin-top: 49px;

        .upload-btn {
          width: 301px;
          height: 301px;
          background: #f5f8f7;
          border: 1px dashed #cccccc;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;

          .btn-icon {
            width: 82px;
            height: 63px;
          }

          .btn-text {
            margin-top: 28px;
            margin-bottom: 19px;
            font-weight: bold;
            color: #5b5f66;
            font-size: 16px;
          }

          .btn-desc {
            color: #999999;
            font-size: 13px;
          }
        }

        .upload-res {
          position: relative;
          width: 300px;
          height: 300px;
          overflow: visible;

          .res-img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }

          .remove-btn {
            position: absolute;
            top: -10px;
            right: -10px;
            width: 28px;
            height: 28px;
            z-index: 10;
          }
        }

        .upload-tips {
          display: flex;
          flex-direction: column;
          justify-content: center;

          .tips-title {
            color: #999999;
            font-weight: bold;
            font-size: 16px;
          }

          .tips-content {
            margin-top: 25px;
            color: #808080;
            font-size: 13px;
            line-height: 28px;

            .line {
              width: 100%;
              border-bottom: 1px dashed #cccccc;
              margin: 26px 0;
            }

            .pay-title {
              color: #333333;
              font-size: 16px;
              margin-bottom: 19px;
            }

            .pay-item {
              display: flex;
              align-items: center;
              font-size: 13px;

              .label {
                color: #666666;
              }

              .value {
                color: #1a1a1a;

                span {
                  border-radius: 11px;
                  border: 1px solid #fa3d5a;
                  cursor: pointer;
                  color: #fa3d5a;
                  padding: 3px 10px;
                  margin-left: 10px;
                }
              }
            }
          }
        }

        .btn-box {
          width: 100%;
          display: flex;
          justify-content: center;
          margin-top: 60px;
          margin-bottom: 73px;

          .btn {
            border-radius: 30px;
            width: 260px;
            height: 60px;
            background: #fa3d5a;
            color: #ffffff;
            line-height: 60px;
            cursor: pointer;
            text-align: center;
            font-size: 14px;
          }
        }

        .back-btn {
          width: 100%;
          margin-bottom: 104px;
          color: #575859;
          font-size: 14px;
          cursor: pointer;
        }
      }
      .balance-pay {
        width: 100%;
        padding-bottom: 30px;
        .balance-pay-btn {
          width: 200px;
          height: 50px;
          line-height: 50px;
          text-align: center;
          color: #ffffff;
          background: #fa3d5a;
          border-radius: 30px;
          margin-top: 20px;
          cursor: pointer;
        }
      }
    }
  }
}

@media screen and (min-width: 1280px) and (max-width: 1679px) {
  .container {
    padding: 30px 100px 100px 100px;

    .page {
      width: 100%;
      padding: 0 50px;

      .pay-methods {
        column-gap: 20px;
        margin-top: 25px;

        .methods-box {
          column-gap: 15px;

          .method-items {
            padding: 15px 25px;
            font-size: 15px;
          }
        }
      }

      .header {
        height: 80px;

        .right {
          .money-box {
            .money {
              font-size: 22px;
            }
          }
        }
      }

      .content {
        .img-wrap {
          font-size: 24px;
          margin: 20px 0;

          .icon {
            width: 28px;
            height: 28px;
            margin-right: 8px;
          }
        }

        .code-wrap {
          padding: 50px 0 150px 0;

          .left {
            .qrcode {
              width: 230px;
              height: 230px;
            }
          }

          .right {
            .help {
              margin-left: 80px;
              width: 200px;
              height: 280px;
            }
          }
        }

        .upload-result {
          column-gap: 50px;
          margin-top: 40px;

          .upload-btn {
            width: 250px;
            height: 250px;

            .btn-icon {
              width: 70px;
              height: 54px;
            }
          }

          .upload-res {
            width: 250px;
            height: 250px;
          }

          .upload-tips {
            .tips-content {
              margin-top: 20px;
              font-size: 12px;
              line-height: 24px;

              .line {
                margin: 20px 0;
              }

              .pay-title {
                font-size: 15px;
                margin-bottom: 15px;
              }

              .pay-item {
                font-size: 12px;
              }
            }
          }

          .btn-box {
            margin-top: 40px;
            margin-bottom: 50px;

            .btn {
              width: 220px;
              height: 50px;
              line-height: 50px;
              font-size: 13px;
            }
          }

          .back-btn {
            margin-bottom: 80px;
            font-size: 13px;
          }
        }

        .balance-pay {
          .balance-pay-btn {
            width: 180px;
            height: 45px;
            line-height: 45px;
            font-size: 13px;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1279px) {
  .container {
    padding: 20px 20px 50px 20px;

    .step-box {
      margin-top: 15px;
      margin-bottom: 10px;

      .step-title {
        column-gap: 8px;

        .step-num {
          width: 18px;
          height: 18px;
          line-height: 18px;
          font-size: 12px;
        }

        .step-name {
          font-size: 16px;
        }
      }

      .step-desc {
        font-size: 12px;
      }
    }

    .page {
      width: 100%;
      padding: 0 20px;
      border-radius: 8px;

      .pay-methods {
        column-gap: 15px;
        margin-top: 20px;
        flex-wrap: wrap;

        .pay-title {
          font-size: 15px;
        }

        .methods-box {
          column-gap: 10px;
          flex-wrap: wrap;

          .method-items {
            padding: 12px 20px;
            font-size: 14px;
          }
        }
      }

      .header {
        height: 70px;

        .right {
          .money-box {
            .money {
              font-size: 20px;
            }
          }

          .pay-tips {
            font-size: 11px;
            margin-top: 8px;
          }
        }
      }

      .content {
        .img-wrap {
          font-size: 22px;
          margin: 15px 0;

          .icon {
            width: 24px;
            height: 24px;
            margin-right: 6px;
          }
        }

        .tip {
          font-size: 13px;

          .second {
            font-size: 13px;
          }
        }

        .code-wrap {
          padding: 40px 0 100px 0;
          flex-direction: column;
          row-gap: 30px;

          .left {
            .qrcode {
              width: 200px;
              height: 200px;
            }

            .hint {
              padding: 4px 8px;
              font-size: 12px;
            }
          }

          .right {
            .help {
              margin-left: 0;
              width: 180px;
              height: 240px;
            }
          }
        }

        .upload-result {
          column-gap: 30px;
          margin-top: 30px;
          flex-direction: column;

          .upload-btn {
            width: 200px;
            height: 200px;

            .btn-icon {
              width: 50px;
              height: 38px;
            }

            .btn-text {
              margin-top: 20px;
              margin-bottom: 15px;
              font-size: 14px;
            }

            .btn-desc {
              font-size: 12px;
            }
          }

          .upload-res {
            width: 200px;
            height: 200px;
          }

          .upload-tips {
            .tips-title {
              font-size: 14px;
            }

            .tips-content {
              margin-top: 15px;
              font-size: 11px;
              line-height: 20px;

              .line {
                margin: 15px 0;
              }

              .pay-title {
                font-size: 14px;
                margin-bottom: 12px;
              }

              .pay-item {
                font-size: 11px;
              }
            }
          }

          .btn-box {
            margin-top: 30px;
            margin-bottom: 40px;

            .btn {
              width: 180px;
              height: 45px;
              line-height: 45px;
              font-size: 12px;
            }
          }

          .back-btn {
            margin-bottom: 50px;
            font-size: 12px;
          }
        }

        .balance-pay {
          padding-bottom: 20px;

          .balance-pay-btn {
            width: 150px;
            height: 40px;
            line-height: 40px;
            font-size: 12px;
            margin-top: 15px;
          }
        }
      }
    }
  }
}

::v-deep .ivu-upload-drag {
  overflow: visible;
}
</style>
